import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment-timezone'
import momentDurationFormat from 'moment-duration-format'
momentDurationFormat(moment)

Vue.use(VueI18n)

const defaultLanguage = 'ja'

const importLanguageDefinition = lang => {
  try {
    const com = require(`@/common/lang/${lang}.json`)
    const app = require(`@/app/lang/${lang}.json`)
    return Object.assign({}, com, app)
  } catch (e) {
    console.log(`Unsupported language [${lang}].`)
    return {}
  }
}

const messages = importLanguageDefinition(defaultLanguage)

const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  silentTranslationWarn: false
})
i18n.setLocaleMessage(defaultLanguage, messages)
i18n.setDateTimeFormat(defaultLanguage, messages._dateTimeFormats || {})

const loadedLanguages = [defaultLanguage]

function setI18nLanguage (lang) {
  i18n.locale = lang
  return lang
}

export function loadLanguage (lang, tz) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      const msgs = importLanguageDefinition(lang)
      i18n.setLocaleMessage(lang, msgs)
      i18n.setDateTimeFormat(lang, msgs._dateTimeFormats || {})
      loadedLanguages.push(lang)
      moment.locale(lang)
      moment.tz.setDefault(tz)
      return setI18nLanguage(lang)
    }
    return setI18nLanguage(lang)
  }
  return lang
}

moment.locale(process.env.APP_LOCALE)
moment.tz.setDefault(process.env.APP_TIMEZONE)
Vue.prototype.$moment = moment

Vue.filter('number', (value, digits) => {
  const d = typeof digits === 'undefined' ? 0 : digits
  return Intl.NumberFormat(i18n.locale, {
    style: 'decimal',
    minimumFractionDigits: d
  }).format(value)
})
Vue.filter('date', (value, format = 'YYYY-MM-DD') => {
  if (value === null) {
    return null
  }
  const f = typeof format === 'undefined' ? 'L' : format
  return moment(value)
    .locale(i18n.locale)
    .format(f)
})
export default i18n



// WEBPACK FOOTER //
// ./src/common/plugins/i18n.js